import { Map, Record } from 'immutable'
import { handleActions } from 'redux-actions'

import { changeTargetStatus } from '@albacross/frontend-utils'

import c from 'constants/campaign-targets-constants'

// This slice holds ONLY the running/paused selection (the list is TanStack server-cache); the meta.updates path is kept so consumers read it unchanged.
const SelectionRecord = Record({
  meta: Map({
    updates: Map({
      running: Map(),
      paused: Map(),
    }),
  }),
})

const initialState = SelectionRecord()

const changeTargetState = (toAddKey: any, toRemoveKey: any) => (s: any, a: any) => {
  const updates = changeTargetStatus(toAddKey, toRemoveKey)(s.meta.get('updates'), a.payload)
  return s.merge({ meta: s.meta.set('updates', updates) })
}

export default handleActions(
  {
    [c.ADD_RUNNING]: changeTargetState('running', 'paused'),

    [c.ADD_PAUSED]: changeTargetState('paused', 'running'),

    [c.CLEAR_SELECTION]: () => initialState,
  },
  initialState,
)
